jQuery(document).ready(function( $ ) {

	// SLIDER *********************
	$('.home-slider').bxSlider({
	  mode: 'fade',
	  pager: false,
	  controls: false,
	  auto: true
	});

	// MOBILE NAVIGATION TOGGLE **************
	$( ".mobile-nav" ).click(function() {
		$( this ).toggleClass( "open" );
		$( ".mobile-menu--wrapper" ).slideToggle();
	});

	$('.wpcf7-submit').wrap("<div class='button-style red'></div>");


	var initialPos =  $('.header-wrapper').offset().top;
	// STICKY NAV *******************
	$(window).on('scroll', function(){
		var top = $(window).scrollTop();
	    if (top > initialPos) {
	        $('.header-wrapper').addClass('sticky');
	        $('body').addClass('sticky-nav-on');
	    }
	    else {
	        $('.header-wrapper').removeClass('sticky');
	        $('body').removeClass('sticky-nav-on');
	    }
	});

	// SCROLL TO HASHTAG NAV *******************
	$('.home a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
	    // On-page links
	    if (
	      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	      && 
	      location.hostname == this.hostname
	    ) {
	      // Figure out element to scroll to
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	      // Does a scroll target exist?

	      if (target.length) {
	        // Only prevent default if animation is actually gonna happen
	        var top_padding = 110;
	        event.preventDefault();
	        $('html, body').animate({
	          scrollTop: target.offset().top - top_padding
	        }, 1000);
	      }
	    }

	    if ($(window).width() <= 768) {
		    $('.mobile-nav').removeClass( "open" );
			$( ".mobile-menu--wrapper" ).hide();
		}
	});

	// GOOGLE MAP avec popup personnalisé *********************
    var map, popup, Popup;

    var styleMap = [
	    {
	        "featureType": "water",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#e9e9e9"
	            },
	            {
	                "lightness": 17
	            }
	        ]
	    },
	    {
	        "featureType": "landscape",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#f5f5f5"
	            },
	            {
	                "lightness": 20
	            }
	        ]
	    },
	    {
	        "featureType": "road.highway",
	        "elementType": "geometry.fill",
	        "stylers": [
	            {
	                "color": "#ffffff"
	            },
	            {
	                "lightness": 17
	            }
	        ]
	    },
	    {
	        "featureType": "road.highway",
	        "elementType": "geometry.stroke",
	        "stylers": [
	            {
	                "color": "#ffffff"
	            },
	            {
	                "lightness": 29
	            },
	            {
	                "weight": 0.2
	            }
	        ]
	    },
	    {
	        "featureType": "road.arterial",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#ffffff"
	            },
	            {
	                "lightness": 18
	            }
	        ]
	    },
	    {
	        "featureType": "road.local",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#ffffff"
	            },
	            {
	                "lightness": 16
	            }
	        ]
	    },
	    {
	        "featureType": "poi",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#f5f5f5"
	            },
	            {
	                "lightness": 21
	            }
	        ]
	    },
	    {
	        "featureType": "poi.park",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#dedede"
	            },
	            {
	                "lightness": 21
	            }
	        ]
	    },
	    {
	        "elementType": "labels.text.stroke",
	        "stylers": [
	            {
	                "visibility": "on"
	            },
	            {
	                "color": "#ffffff"
	            },
	            {
	                "lightness": 16
	            }
	        ]
	    },
	    {
	        "elementType": "labels.text.fill",
	        "stylers": [
	            {
	                "saturation": 36
	            },
	            {
	                "color": "#333333"
	            },
	            {
	                "lightness": 40
	            }
	        ]
	    },
	    {
	        "elementType": "labels.icon",
	        "stylers": [
	            {
	                "visibility": "off"
	            }
	        ]
	    },
	    {
	        "featureType": "transit",
	        "elementType": "geometry",
	        "stylers": [
	            {
	                "color": "#f2f2f2"
	            },
	            {
	                "lightness": 19
	            }
	        ]
	    },
	    {
	        "featureType": "administrative",
	        "elementType": "geometry.fill",
	        "stylers": [
	            {
	                "color": "#fefefe"
	            },
	            {
	                "lightness": 20
	            }
	        ]
	    },
	    {
	        "featureType": "administrative",
	        "elementType": "geometry.stroke",
	        "stylers": [
	            {
	                "color": "#fefefe"
	            },
	            {
	                "lightness": 17
	            },
	            {
	                "weight": 1.2
	            }
	        ]
	    }
	];


    initMap();

	/** Initializes the map and the custom popup. */
	function initMap() {
		definePopupClass();

		map = new google.maps.Map(document.getElementById('map'), {
			center: {lat: 45.50700, lng: -73.557474},
			zoom: 15,
			styles: styleMap,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			noClear: true,
			disableDefaultUI: false,
			scrollwheel: false,
			draggable: true,
			zoomControl: true,
			streetViewControl: false,
			panControl: false,
			mapTypeControl: false
		});

		popup = new Popup(
			new google.maps.LatLng(45.50428, -73.557474),
			document.getElementById('content')
		);

		popup.setMap(map);
	
	}

	/** Defines the Popup class. */
	function definePopupClass() {

	  Popup = function(position, content) {
	    this.position = position;

	    content.classList.add('popup-bubble-content');

	    var pixelOffset = document.createElement('div');
	    pixelOffset.classList.add('popup-bubble-anchor');
	    pixelOffset.appendChild(content);

	    this.anchor = document.createElement('div');
	    this.anchor.classList.add('popup-tip-anchor');
	    this.anchor.appendChild(pixelOffset);

	    this.stopEventPropagation();
	  };

	  Popup.prototype = Object.create(google.maps.OverlayView.prototype);


	  Popup.prototype.onAdd = function() {
	    this.getPanes().floatPane.appendChild(this.anchor);
	  };

	  Popup.prototype.onRemove = function() {
	    if (this.anchor.parentElement) {
	      this.anchor.parentElement.removeChild(this.anchor);
	    }
	  };


	  Popup.prototype.draw = function() {
	    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

	    var display =
	        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
	        'block' :
	        'none';

	    if (display === 'block') {
	      this.anchor.style.left = divPosition.x + 'px';
	      this.anchor.style.top = divPosition.y + 'px';
	    }
	    if (this.anchor.style.display !== display) {
	      this.anchor.style.display = display;
	    }
	  };

	  /** Stops clicks/drags from bubbling up to the map. */
	  Popup.prototype.stopEventPropagation = function() {
	    var anchor = this.anchor;
	    anchor.style.cursor = 'auto';

	    ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
	     'pointerdown']
	        .forEach(function(event) {
	          anchor.addEventListener(event, function(e) {
	            e.stopPropagation();
	          });
	        });
	  };
	}




	// Functions on RESIZE
	// -----------------------------------------

	$(window).on("resize", function(){
		// SLIDER *********************
		$('.home-slider').bxSlider({
		  mode: 'fade',
		  adaptiveHeight: true
		});
	});

});